var SENTRY_RELEASE;SENTRY_RELEASE={name: "Vuelto Negocio", version: "1.2.0"};